import { useLayoutEffect } from 'react';
import withFieldValidation from '../hocs/withFieldValidation';

interface PostCodeAutoCompleteProps {
    classes?: string;
    onChange: (name: string, value: string) => void;
    disabled?: boolean;
}

const PostCodeAutoCompleteInput = ({
    classes,
    onChange,
    disabled,
}: PostCodeAutoCompleteProps) => {
    useLayoutEffect(() => {
        if ((window as any).pca) (window as any).pca.load();
    }, []);

    useLayoutEffect(() => {
        if ((window as any).pca) {
            const fields = [
                {
                    element: 'addressSearch',
                    field: '',
                    mode: (window as any).pca.fieldMode.SEARCH,
                },
            ];
            const control = new (window as any).pca.Address(fields, {
                key: 'TN13-FY69-WX59-JR16',
            });

            control.listen('populate', address => {
                const addressLine1 = address.Company
                    ? `${address?.Company}, ${address?.Line1 ?? ''}`
                    : address?.Line1 ?? '';
                onChange('addressLine1', addressLine1 ?? '');
                onChange('addressLine2', address?.Line2 ?? '');
                onChange('addressLine3', address?.Line3 ?? '');
                onChange('postcode', address?.PostalCode ?? '');
                onChange('town', address?.City ?? '');
                onChange('streetAddress', address?.Street ?? '');
                onChange(
                    'buildingName',
                    `${address?.SubBuilding ?? ''} ${address?.BuildingName ??
                        ''}`.trim(),
                );
                onChange('buildingNo', address?.BuildingNumber ?? '');
                onChange('country', 'United Kingdom');
                onChange('extAddressId', address?.Id);
                onChange('provider', 'Loqate');
                onChange('addressType', address?.Type.toLowerCase());
            });
        }
    }, [onChange]);

    return (
        <div className={`sm-input postcode ${disabled && 'disabled'}`}>
            <LoqateForm
                disabled={disabled}
                classes={classes}
            />
        </div>
    );
};

const LoqateForm = ({ disabled, classes }) => (
    <div>
        <div className="input-container">
            <i className="auto-complete-icon sm-input-prepend-icon fas fa-search fa-2x"></i>
            <input
                name="addressSearch"
                placeholder="Search postcode or address"
                className={`${classes} location-search-input`}
                disabled={disabled}
            />
        </div>
    </div>
);

export default withFieldValidation(PostCodeAutoCompleteInput);
